import { fireGtagEvent } from '../helpers/gtag-helpers'

/**
 * Catalog of analytics events triggered from Syndication features.
 * Provides a clean interface for describing the tracking events.
 */

export default {
  synArticleClickShareFacebook: () => fireGtagEvent('Clicked Share Button', "Facebook", 'Storypage'),
  synArticleClickShareTwitter: () => fireGtagEvent('Clicked Share Button', "Twitter", 'Storypage'),
  synArticleClickShareEmail: () => fireGtagEvent('Clicked Share Button', "Email", 'Storypage')
};
